import React from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Slider from 'react-slick';
// eslint-disable-next-line no-unused-vars
import slickcss from 'slick-carousel/slick/slick.css';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { inViewForReact, debounce } from 'utils/common';
import s from './PhotosliderWrappr.scss';

import Card from '../../common/CardV2';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';

function PrevArrow(propVal) {
  const { className, style, onClick } = propVal;
  return (
    <button
      type="button"
      className={`${s.arrows} ${s.left} ${className} ${
        propVal.enableBottomArrows ? s.etimes_arrow : ''
      }`}
      style={{ ...style }}
      onClick={onClick}
    />
  );
}

function NextArrow(propVal) {
  const { className, style, onClick } = propVal;
  return (
    <button
      type="button"
      className={`${s.arrows} ${s.right} ${className} ${
        propVal.enableBottomArrows ? s.etimes_arrow : ''
      }`}
      style={{ ...style }}
      onClick={onClick}
    />
  );
}

class PhotoSliderWrappr extends React.Component {
  constructor() {
    super();
    this.state = {};
    this.sliderRef = React.createRef();
    this.debounceHandleScroll = debounce(this.handleGAOnScroll, 10);
  }

  removeScrollEvent = () => {
    if (typeof this.debounceHandleScroll === 'function') {
      window.removeEventListener('scroll', this.debounceHandleScroll);
    }
  };

  handleGAOnScroll = () => {
    if (
      !this.props.isFromEtimesAS &&
      this.sliderRef &&
      this.sliderRef.current &&
      inViewForReact(this.sliderRef.current, 0, true)
    ) {
      const gaData = {
        gaCategory: 'WEB-articleshowv2  ',
        gaAction: `View_${this.props.gaSecName}`,
        nonInteraction: true,
      };
      this.sendGA(gaData);
      this.removeScrollEvent();
    }
  };

  sendGA = data => {
    sendGaThroughProps({
      data,
    });
  };

  componentDidMount() {
    window.addEventListener('scroll', this.debounceHandleScroll);

    const { sectionData = {} } = this.props;
    if (
      !(sectionData && sectionData?.msid === 'newPhotostory') &&
      sectionData.dataUrl
    ) {
      this.loadCompareData(sectionData.dataUrl);
    }
  }

  componentWillUnmount() {
    this.removeScrollEvent();
  }

  loadCompareData(dataUrl) {
    if (!dataUrl) {
      return;
    }

    makeRequest
      .get(dataUrl, { isMobile: false }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          this.setState({
            items: data.data.items,
          });
        }
      });
  }

  render() {
    const {
      sectionData = {},
      slidesToShow,
      draggableSlider = false,
      isFromEtimesAS,
      isFromEtimesPS,
      ga4Type,
    } = this.props;

    let { items } = this.state;

    if (sectionData && sectionData?.msid === 'newPhotostory') {
      items = sectionData.items;
    }

    if (!items || items.length === 0) {
      return null;
    }
    const settings = {
      dots: true,
      slidesToShow: slidesToShow || 3,
      slidesToScroll: slidesToShow || 3,
      nextArrow: (
        <NextArrow enableBottomArrows={this.props.enableBottomArrows} />
      ),
      prevArrow: (
        <PrevArrow enableBottomArrows={this.props.enableBottomArrows} />
      ),
      infinite: false,
      draggable: draggableSlider,
      arrows: true,
      dotsClass: s.dots,
    };

    return (
      <div
        className={`${s.coronaPhotoSlider} photosslider ${
          this.props.wrapperClass ? s[this.props.wrapperClass] : ''
        }`}
        ref={this.sliderRef}
      >
        <Listingheader
          headingname={sectionData.name}
          headingLink={this.props.path}
          newga={`${this.props.name}Section_Actions#HeadingClick`}
        />
        <div className={` ${s.photo_widget_slider} slick_UI`}>
          <Slider {...settings}>
            {items.map((item, index) => (
              <Card
                data={item}
                isVerticalTile
                newga={
                  isFromEtimesAS
                    ? ''
                    : `Click${index}_${this.props.gaSecName}#${item.wu}`
                }
                imgWidth="200"
                target
                onClick={() => {
                  if (isFromEtimesPS) {
                    analyticsWrapper('ga4', {
                      event: 'user_click',
                      type: ga4Type || 'photostories_widget',
                      category: 'story_click',
                      story_no: index + 1,
                    });
                  }
                  if (
                    isFromEtimesAS &&
                    sectionData &&
                    sectionData?.ga4Type &&
                    sectionData?.ga4Type !== ''
                  ) {
                    analyticsWrapper('ga4', {
                      event: 'user_click',
                      type: sectionData?.ga4Type,
                      category: 'story_click',
                      story_no: index + 1,
                    });
                    sendGaThroughProps({
                      data: {
                        gaAction: 'click-photostories',
                        gaLabel: `${index}-${item.wu}`,
                      },
                    });
                  }
                }}
              />
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}

PhotoSliderWrappr.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
  gridRequired: PropTypes.string,
  oneByOneCard: PropTypes.string,
  gaSecName: PropTypes.string,
  slidesToShow: PropTypes.number,
  draggableSlider: PropTypes.bool,
  enableBottomArrows: PropTypes.bool,
  isFromEtimesAS: PropTypes.bool,
};

PhotoSliderWrappr.defaultProps = {
  gridRequired: '',
  oneByOneCard: '',
  gaSecName: 'India Fights Covid',
  slidesToShow: undefined,
  draggableSlider: false,
  enableBottomArrows: false,
  isFromEtimesAS: false,
};

export default PhotoSliderWrappr;
